// GAVION granola partners (spec 2026-10-26 §5): the number of « À associer » notes on the « Réunions » menu — a rep's
// own, an admin's everyone's (RLS limits the rows; the filter mirrors MeetingsPage). Hidden at 0, 99+ above 99.
import {
  useGetIdentity,
  useGetList,
  usePermissions,
  useTranslate,
} from "ra-core";
import { SidebarMenuBadge } from "@/components/ui/sidebar";

const POLL_MS = 5 * 60_000;

export function useUnmatchedNoteCount(): number {
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions();
  const isAdmin = permissions === "admin";
  const filter: Record<string, unknown> = { match_status: "unmatched" };
  if (!isAdmin) filter.owner_sales_id = identity?.id;
  const { total } = useGetList(
    "meeting_notes",
    {
      filter,
      sort: { field: "started_at", order: "DESC" },
      pagination: { page: 1, perPage: 1 },
    },
    {
      enabled: identity?.id != null && permissions !== undefined,
      retry: false,
      refetchInterval: POLL_MS,
    },
  );
  return total ?? 0;
}

const shown = (n: number) => (n > 99 ? "99+" : String(n));

export const MeetingsNavBadge = () => {
  const t = useTranslate();
  const n = useUnmatchedNoteCount();
  if (n === 0) return null;
  return (
    <SidebarMenuBadge
      aria-label={t("gavion.meetings.badge", { smart_count: n })}
    >
      {shown(n)}
    </SidebarMenuBadge>
  );
};

export const MeetingsCount = () => {
  const t = useTranslate();
  const n = useUnmatchedNoteCount();
  if (n === 0) return null;
  return (
    <span
      className="ml-auto rounded-full bg-primary px-2 text-xs text-primary-foreground"
      aria-label={t("gavion.meetings.badge", { smart_count: n })}
    >
      {shown(n)}
    </span>
  );
};
